module.exports = __webpack_public_path__ + "static/media/t_icon_04.ccbd656f.png";